import { redirect } from 'react-router-dom';

import { getMe } from 'src/services/getMe';
import { isUnauthorizedError } from 'src/utils/helpers/isUnauthorizedError';
import { getSafeReturnPath } from '../constants';

export const noAccessLoader = async ({ request }) => {
	try {
		const me = await getMe({ fetchPolicy: 'network-only' });

		if (me) {
			return redirect(getSafeReturnPath(request));
		}
	} catch (error) {
		if (isUnauthorizedError(error)) {
			return null;
		}

		throw error;
	}

	return null;
};
